import api from 'axios'
import moment from 'moment'

const state = {
  me: null
}

const actions = {
  getLoggedInUser ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.get('/me')
        .then(
          response => {
            commit('SET_USER', response.data)
            resolve()
          }
        )
        .catch(
          error => {
            commit('UNSET_USER')
            error.response ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  updateProfile ({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      api.post('/me/profile', data)
        .then(
          response => {
            commit('SET_USER', response.data.user)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            error.response ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  updateEmail ({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      api.post('/me/email', data)
        .then(
          response => {
            commit('SET_USER', response.data.user)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            error.response ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  updatePassword ({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      api.post('/me/password', data)
        .then(
          response => {
            resolve(response.data)
          }
        )
        .catch(
          error => {
            error.response ? reject(error.response.data) : reject(error)
          }
        )
    })
  }
}

const mutations = {
  SET_USER (state, data) {
    state.me = data
    localStorage.setItem('account_data_retrieved_at', moment().unix())
  },
  UNSET_USER (state) {
    state.me = null
  }
}

export default {
  state,
  actions,
  mutations
}
